import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({ selector: '[fieldBlur]' })
export class FieldBlurDirective {
    @Output() fieldBlur = new EventEmitter<void>();

    @HostListener('focusout', ['$event'])
    onFocusOut(event: FocusEvent): void {
        const host = event.currentTarget as HTMLElement;
        if (!host.contains(event.relatedTarget as Node)) {
            this.fieldBlur.emit();
        }
    }
}